var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serp-banner",class:[
    'serp-banner__position_' + _vm.position,
     _vm.isMobile ? 'mobile' : ''
     ]},[_c('img',{attrs:{"src":_vm.getImageUrl(_vm.imageSrc)},on:{"click":_vm.openImageLink}})])
}
var staticRenderFns = []

export { render, staticRenderFns }